import React, { useEffect, useState } from 'react';
import '../../Assets/CSS/profile.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import axios from 'axios';
import { getCookie } from '../../components/auth/login/GetCookie';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

const ProfileInfo = ({ setActiveTab, setProfileData }) => {
  const [profileInfo, setProfileInfo] = useState(null);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const navigate = useNavigate();

  const fetchProfile = async () => {
    // const token = localStorage.getItem("token");
    const token = getCookie("token");
    try {
      const response = await axios.get(`${API_URL}/api/v1/users/my-profile`, {
        headers: {
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`,
        }
      });
      setProfileInfo(response.data);
      setProfileData(response.data)
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const cookieOptions = {
    //secure: process.env.NODE_ENV === 'production', // Secure in production
    //sameSite: 'strict',
    sameSite: 'Lax',   // ✅ best choice for HTTP
    path: '/',
    expires: 1 // 1 day expiration
  };

  const handleDeleteUser = async (e) => {

    e.preventDefault(); // Prevent default form submission behavior
    e.stopPropagation(); // Stop event bubbling
    setIsDeleting(true);
    const token = getCookie("token");

    try {
      await axios.delete(`${API_URL}/api/v1/users/my-profile`, {
        headers: {
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`,
        }
      });

      // Clear user data and redirect
      document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      // localStorage.clear();
      Cookies.remove('token', cookieOptions);
      navigate('/'); // or wherever you want to redirect after deletion
      // Show success toast
      toast.success('Account deleted successfully!');

      setTimeout(() => window.location.reload(), 100);

    } catch (error) {
      console.error('Error deleting user:', error.response ? error.response.data : error.message);
      alert('Failed to delete account. Please try again.');
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };



  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="row px-2">
        <div className="col-md-12">
          <div className="d-flex border-bottom pb-2 justify-content-between align-items-center">
            <h5 className="fw-bold fs-4 lh-base text-center pt-4">My Profile</h5>
            <button
              className="reg-btn btn-green gap-3 py-1 rounded px-3"
              onClick={() => setActiveTab("editProfile")}
            >
              <Icon icon="material-symbols:edit" />
              Edit
            </button>
          </div>

          <h6 className="fs-5 fw-500 lh-base text-secondary pt-3">Profile Photo</h6>
          <div className="d-flex align-items-center position-relative">
            {profileInfo ? (
              <img src={profileInfo.profileImageUrl || 'default-profile.png'} alt="profile" className="img-fluid profile" />
            ) : (
              <Skeleton circle width={100} height={100} />
            )}
          </div>

          <div className="row">
            <div className="col-md-12">
              <h5 className="fw-bold fs-5 text-secondary pt-5">Account Information</h5>

              <div className="d-flex position-relative gap-4 justify-content-between">
                <div className="form-control rounded-3 ps-5 bg-white">
                  {profileInfo ? profileInfo.firstName : <Skeleton width={100} />}
                </div>
                <div className="form-control rounded-3 ps-5 bg-white">
                  {profileInfo ? profileInfo.lastName : <Skeleton width={100} />}
                </div>
              </div>

              <div className="d-flex position-relative mb-3 mt-3 gap-4 justify-content-between">
                <div className="form-control rounded-3 ps-5 bg-white">
                  {profileInfo ? profileInfo.mobileNumber : <Skeleton width={150} />}
                </div>
                <div className="form-control rounded-3 ps-5 bg-white">
                  {profileInfo ? profileInfo.email : <Skeleton width={200} />}
                </div>
              </div>

              <div className="d-flex mb-3 mt-3 position-relative gap-4 justify-content-between">
                <div className="form-control rounded-3 ps-5 bg-white">
                  ********
                </div>
                <div className="form-control rounded-3 ps-5 bg-white">
                  {profileInfo ? profileInfo.countryName : <Skeleton width={150} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mb-2'>
        <button
          type="button" // Important: specify type="button" to prevent form submission
          className="text-danger text-start logout-button border-0 bg-white w-100"
          style={{ marginTop: '155px' }}
          onClick={() => setShowDeleteModal(true)}

        >
          <span className="logout-icon">
            <Icon icon='material-symbols:delete-outline' className="fs-3 p-1" />
          </span>
          Delete Account
        </button>
      </div>

      {/* Enhanced Modal */}

      {/* Enhanced Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => !isDeleting && setShowDeleteModal(false)}
        centered
        backdrop={isDeleting ? 'static' : true}
        keyboard={!isDeleting}
        contentClassName="border-0"
      >
        <Modal.Header closeButton={!isDeleting}
          className="border-0 justify-content-center mb-0"// Removes bottom border from header

        >
          <Modal.Title className="text-center w-100 fs-5 fw-bold">Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center py-1'>
          <p className="mb-0">Are you sure you want to delete your account? This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer
          className="border-0 mb-3 justify-content-center" // Removes bottom border from header
        >
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            disabled={isDeleting}
            className="mx-3"
          >
            Cancel
          </Button>
          <Button
            // variant="danger" 
            onClick={handleDeleteUser}
            disabled={isDeleting}
            style={{ backgroundColor: '#FDC400', border: '1px solid #FDC400' }}
            className="mx-2"
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default ProfileInfo;
